<template>
  <Modal :open="true" @close="$emit('close')">
    <h1 class="text-center font-extrabold text-xl">{{ t("title") }}</h1>
    <p class="text-center text-sm text-gray-500 mt-1">{{ storeName }}</p>

    <Loading v-if="loading" />
    <div v-else class="mt-5">
      <Selector
        id="sales_manager"
        name="sales_manager"
        v-model="selectedSalesManagerId"
        :label="t('sales_manager')"
        :options="salesManagerOptions"
        :defaultOptionText="t('no_sales_manager')"
      />

      <div class="text-center mt-7 mb-5">
        <GenericButton :disabled="saving" @click="save">{{ t("submit") }}</GenericButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import { Modal, Loading, Selector, GenericButton } from "@estaly/ui";

const ALL_INSURER_MANAGERS_PER_PAGE = 1000;

export default {
  components: { Modal, Loading, Selector, GenericButton },

  props: {
    storeId: { type: Number, required: true },
    storeName: { type: String, default: "" },
    salesManagerId: { type: Number, default: null },
  },

  emits: ["close", "updated"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      loading: true,
      saving: false,
      selectedSalesManagerId: this.salesManagerId ?? "",
    };
  },

  computed: {
    ...mapState("insurerManagers", { insurerManagers: "index" }),

    salesManagerOptions() {
      return this.insurerManagers
        .filter((insurerManager) => insurerManager.role === "sales_manager")
        .map((insurerManager) => ({
          value: insurerManager.id,
          label: [insurerManager.firstName, insurerManager.lastName].filter(Boolean).join(" ") || insurerManager.email,
        }));
    },
  },

  async created() {
    this.loading = true;
    try {
      await this.fetchInsurerManagers({ perPage: ALL_INSURER_MANAGERS_PER_PAGE });
    } finally {
      this.loading = false;
    }
  },

  methods: {
    ...mapActions("insurerManagers", { fetchInsurerManagers: "fetchIndex" }),
    ...mapActions("stores", ["updateSalesManager"]),

    async save() {
      this.saving = true;
      try {
        const response = await this.updateSalesManager({
          storeId: this.storeId,
          insurerManagerId: this.selectedSalesManagerId || null,
        });
        if (!response?.success) return;

        this.$emit("updated");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<i18n src="./StoreSalesManagerModal.i18n.json"></i18n>
